import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { Outlet } from "react-router-dom";

import { useGetAdminRolesAssignmentQuery } from "@/api/admin";
import { rootStore } from "@/store/RootStore";

const AdminBootstrapLayout = observer(() => {
  const enabled = rootStore.authStore.isAdmin;
  const { data, isPending } = useGetAdminRolesAssignmentQuery(enabled);

  useEffect(() => {
    if (data) {
      rootStore.adminAccessStore.setPermissions(data.permissions);
    }
  }, [data]);

  const isReady = !enabled || rootStore.adminAccessStore.isBootstrapped;

  if (enabled && !isReady && isPending) {
    return <></>;
  }

  return <Outlet />;
});

export default AdminBootstrapLayout;
